import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangeBankLazy = lazyLoader(
  () =>
    import('./ChangeBankAccount' /* webpackChunkName: "change-bank-account" */),
);

const ChangeBankAccount = () => {
  return (
    <Suspense fallback={null}>
      <ChangeBankLazy />
    </Suspense>
  );
};

export default ChangeBankAccount;
